import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { style: {"width":"100%"} }

import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import VehicleRegistration from "@/shared/model/VehicleRegistration";
import {useAccountStore} from "@/stores/accountStore";
import {ref} from "vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";

interface Props {
  data?: VehicleRegistration,
  visibleInsuranceNumber?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleRegistrationFullComponent',
  props: {
    data: { default: undefined },
    visibleInsuranceNumber: { type: Boolean, default: true }
  },
  setup(__props: any) {


const props = __props

const _accountStore = useAccountStore()
const _isRoot = ref(_accountStore.isRoot)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _withDirectives(_createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("td", null, "Nummer", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.insuranceNumber
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.visibleInsuranceNumber]
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[1] || (_cache[1] = _createElementVNode("td", null, "eVb", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.evb
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.visibleInsuranceNumber&&__props.data?.evb]
      ]),
      _createElementVNode("tr", null, [
        _cache[2] || (_cache[2] = _createElementVNode("td", null, "Kennzeichen", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.kennzeichen
          }, null, 8, ["value"])
        ])
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[3] || (_cache[3] = _createElementVNode("td", null, "GDV Vers.-Scheinnummer", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.versicherungsScheinnummer
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.visibleInsuranceNumber && _isRoot.value]
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[4] || (_cache[4] = _createElementVNode("td", null, "GDV VB-Nummer", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.versicherungsBestaetigungsNummer
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.visibleInsuranceNumber && _isRoot.value]
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[5] || (_cache[5] = _createElementVNode("td", null, "GDV-Versicherungsbeginn", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.datumVersicherungsBeginn,
            "value-type": "Date"
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.data?.datumVersicherungsBeginn]
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[6] || (_cache[6] = _createElementVNode("td", null, "Kennzeichen gültig bis", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.kennzeichenDatumGueltigBis,
            "value-type": "Date"
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, __props.data?.kennzeichenDatumGueltigBis]
      ]),
      _createElementVNode("tr", null, [
        _cache[7] || (_cache[7] = _createElementVNode("td", null, "FIN", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.fahrzeugIdentifizierungsNummer
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[8] || (_cache[8] = _createElementVNode("td", null, "Fahrzeugart", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data?.fahrzeugArtDescription), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[9] || (_cache[9] = _createElementVNode("td", null, "Hersteller", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data?.fahrzeugHersteller), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[10] || (_cache[10] = _createElementVNode("td", null, "Text Fahrzeugklasse", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data?.textFahrzeugklasse), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[11] || (_cache[11] = _createElementVNode("td", null, "Text Aufbau", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data?.textAufbau), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[12] || (_cache[12] = _createElementVNode("td", null, "Haltername", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data?.halterVorname) + " " + _toDisplayString(__props.data?.halterNachname), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[13] || (_cache[13] = _createElementVNode("td", null, "Halteraddresse", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data?.halterStrasse) + " " + _toDisplayString(__props.data?.halterHausnummer), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.data?.halterPostleitzahl) + " " + _toDisplayString(__props.data?.halterWohnort), 1),
              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(_toDisplayString(__props.data?.halterStaat), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[16] || (_cache[16] = _createElementVNode("td", null, "Status", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.statusDescription
          }, null, 8, ["value"])
        ])
      ], 512), [
        [_vShow, _isRoot.value && __props.data?.statusId]
      ]),
      _withDirectives(_createElementVNode("tr", null, [
        _cache[17] || (_cache[17] = _createElementVNode("td", null, "Vertragsende", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            "value-type": _unref(SogDataLabelValueType).DateTime,
            value: __props.data?.vertragsEnde
          }, null, 8, ["value-type", "value"])
        ])
      ], 512), [
        [_vShow, _isRoot.value && __props.data?.vertragsEnde]
      ])
    ])
  ]))
}
}

})